import SentimentBadge from '@/features/Feedback/field/Sentiment/SentimentBadge';
import { sentimentMap } from '@/types/feedbackConst';
import { SENTIMENT_COLUMNS } from '@/types/filterKeyConst';
import { orderedSentiment } from '@/types/sentimentConst';

const getSentimentFilterItemFetcher = (columnKey: string) => {
  return async (params?: StructuredColumnFetcherParams) => {
    const searchValue = params?.searchValue?.toLocaleLowerCase();
    return orderedSentiment
      .map((key) => ({
        columnKey: columnKey,
        filterKey: key,
        filterName: sentimentMap[key].value,
        searchValue: sentimentMap[key].value,
        filterOptionNode: <SentimentBadge type={key} />,
      }))
      .filter((item) => {
        if (!searchValue) return true;
        return item.searchValue.toLocaleLowerCase().includes(searchValue);
      });
  };
};

export const useSentimentFilterMap = () => {
  const fieldOptions: StructuredFieldOptionMap = {
    [SENTIMENT_COLUMNS.SENTIMENT_DETAIL]: {
      columnKey: SENTIMENT_COLUMNS.SENTIMENT_DETAIL,
      columnName: 'Sentiments',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: getSentimentFilterItemFetcher(
          SENTIMENT_COLUMNS.SENTIMENT_DETAIL,
        ),
      },
    },
    [SENTIMENT_COLUMNS.KEY_SENTIMENT]: {
      columnKey: SENTIMENT_COLUMNS.KEY_SENTIMENT,
      columnName: 'Key sentiment',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: getSentimentFilterItemFetcher(
          SENTIMENT_COLUMNS.KEY_SENTIMENT,
        ),
      },
    },
    [SENTIMENT_COLUMNS.ENDING_SENTIMENT]: {
      columnKey: SENTIMENT_COLUMNS.ENDING_SENTIMENT,
      columnName: 'End sentiment',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: getSentimentFilterItemFetcher(
          SENTIMENT_COLUMNS.ENDING_SENTIMENT,
        ),
      },
    },
  };

  return fieldOptions;
};
